export interface Point {
  x: number
  y: number
  z: number
}

export interface StoreyLocation {
  x?: number | string | null
  y?: number | string | null
}

/** Form fields hand back strings, so every coordinate is coerced before use. */
export const toCentroid = (location?: StoreyLocation, z?: number): Point | undefined => {
  if (!location || z === undefined) return undefined

  const x = Number(location.x)
  const y = Number(location.y)

  if (!Number.isFinite(x) || !Number.isFinite(y)) return undefined

  return { x, y, z }
}

/**
 * Elevation of each storey's ceiling above the base, as the substitute force
 * calculation derives it: the storey heights summed from the bottom up.
 *
 * A storey whose height is not a usable number ends the chain - everything
 * above it would otherwise be placed at an elevation that is quietly wrong.
 */
export const toStoreyElevations = (
  storeyInputs: { height?: number | string | null }[] | undefined,
  storeys: number[],
): Record<number, number> => {
  const elevations: Record<number, number> = {}
  let elevation = 0

  for (const storey of [...storeys].sort((a, b) => a - b)) {
    const raw = storeyInputs?.[storey]?.height
    if (raw === null || raw === undefined || raw === '') break

    const height = Number(raw)
    if (!Number.isFinite(height) || height <= 0) break

    elevation += height
    elevations[storey] = elevation
  }

  return elevations
}
